export type PaginationEntry = number | 'ellipsis';

// ? Always first + last page, current page ±1 (at least 3 pages wide at the edges),
// ? every gap — even a single missing page — collapses into an ellipsis.
export const getPaginationItems = (currentPage: number, totalPages: number): PaginationEntry[] => {
  if (totalPages <= 1) {
    return [];
  }

  const page = Math.min(Math.max(currentPage, 1), totalPages);
  const windowStart = Math.max(1, Math.min(page - 1, totalPages - 2));
  const windowEnd = Math.min(totalPages, Math.max(page + 1, 3));

  const pages = [1];
  for (let i = Math.max(windowStart, 2); i <= windowEnd; i++) {
    pages.push(i);
  }
  if (windowEnd < totalPages) {
    pages.push(totalPages);
  }

  return pages.flatMap((pageNumber, index) =>
    index > 0 && pageNumber - pages[index - 1] > 1 ? ['ellipsis', pageNumber] : [pageNumber]
  );
};
